//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeMessageListApi, noticeMessageReadApi, noticeMessageDeleteApi } from '@/api/user';
import { messageListApi } from '@/api/public';
export default {
  name: 'Apply',
  components: {
    dialogForm: function dialogForm() {
      return import('./components/index');
    },
    formBox: function formBox() {
      return import('./components/formBox');
    },
    messageDetails: function messageDetails() {
      return import('./components/messageDetails');
    }
  },
  data: function data() {
    return {
      rolesConfig: [],
      formBoxConfig: {},
      tableData: [],
      activeName: '1',
      multipleSelection: [],
      messageData: {},
      where: {
        page: 1,
        limit: 15,
        title: '',
        cate_id: '',
        is_read: 0
      },
      total: 0,
      loading: false
    };
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    // 获取列表
    getTableData: function getTableData() {
      var _this = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (type === 1) {
        this.loading = true;
      }
      noticeMessageListApi(this.where).then(function (res) {
        if (type === 1) {
          _this.loading = false;
        }
        _this.tableData = res.data.list;
        _this.total = res.data.messageNum;
        if (_this.activeName === '1') {
          _this.$store.commit('user/SET_MESSAGE', _this.total);
        }
      }).catch(function () {
        if (type === 1) {
          _this.loading = false;
        }
      });
    },
    handleClick: function handleClick() {
      this.where.page = 1;
      if (this.activeName == 1) {
        this.where.is_read = 0;
      } else {
        this.where.is_read = '';
      }
      this.getTableData();
    },
    confirmData: function confirmData(data) {
      this.where.page = 1;
      this.where.title = data.name;
      this.where.cate_id = data.types;
      this.getTableData();
    },
    handleDelete: function handleDelete() {
      var _this2 = this;
      if (this.multipleSelection.length <= 0) {
        this.$message.error('至少选择一项内容');
      } else {
        this.$modalSure('删除后不可恢复,您确认要删除吗').then(function () {
          var ids = [];
          _this2.multipleSelection.map(function (value) {
            ids.push(value.id);
          });
          _this2.batchMessageDelete({
            ids: ids
          });
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDetails: function handleDetails(row) {
      this.messageData = {
        width: '560px',
        data: row
      };
      this.$refs.messageDetails.handleOpen();
    },
    isOk: function isOk() {
      this.getTableData(0);
    },
    handleIsRead: function handleIsRead() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('至少选择一项内容');
      } else {
        var ids = [];
        this.multipleSelection.map(function (value) {
          ids.push(value.id);
        });
        this.batchMessageRead(1, {
          ids: ids
        }, 1);
      }
    },
    // 批量标记未已读
    batchMessageRead: function batchMessageRead(status, data, type) {
      var _this3 = this;
      noticeMessageReadApi(status, data).then(function () {
        _this3.getMessage();
        _this3.getTableData();
      });
    },
    // 批量删除消息
    batchMessageDelete: function batchMessageDelete(data) {
      var _this4 = this;
      noticeMessageDeleteApi(data).then(function () {
        _this4.getMessage();
        _this4.getTableData();
      });
    },
    // 消息数量
    getMessage: function getMessage() {
      var _this5 = this;
      messageListApi({
        page: 1,
        limit: 5
      }).then(function (res) {
        var num = res.data.messageNum ? res.data.messageNum : 0;
        _this5.$store.commit('user/SET_MESSAGE', num);
      });
    }
  }
};